

















import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { PolygonLayer } from "@/model/document2/page/surface/design/layer/polygonLayer";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class PolygonRadiusController extends Vue 
{
    @Prop() layer! : PolygonLayer;

    private get radius()
    {
        return this.layer.radius;
    }

    private set radius(radius)
    {
        this.changeLayerProperty("radius", Number(radius), false, false);
    }

    private get radiusText()
    {
        return this.layer.radius.toFixed() + "%";
    }

    private onRadiusChanged()
    {
        this.changeLayerProperty("radius", this.layer.radius, true, false);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }
}
